// Gegenereerd door scripts/build-own-art.mjs; niet met de hand bewerken.
// Pictogrammen die nog donkere lijnen hebben (OpenMoji of de oude eigen stijl) en in het donker
// een licht plaatje nodig hebben. Eigen tekeningen in de nieuwe stijl staan er niet in.
export const DARK_LINE_PICTO_IDS: ReadonlyArray<string> = [];
